import { ListItem, ListItemButton, ListItemText } from "@mui/material";

interface ItemRendererProps<T> {
  selected: boolean;
  item: T;
  text: string;
  handleSelectedItem: (selectedItem: T) => void
}

export const ItemRenderer = <T,>(props: ItemRendererProps<T>) => {
  return (
    <ListItem disablePadding disableGutters>
      <ListItemButton
        disableGutters
        selected={props.selected}
        style={props.selected ? { backgroundColor: "#0072da" } : {}}
        onClick={() => props.handleSelectedItem(props.item)}
      >
        <ListItemText
          primary={props.text}
          sx={{
            margin: 0,
            paddingInline: "1rem",
          }}
          primaryTypographyProps={{
            style: {
              overflow: "hidden",
              textWrap: "nowrap",
              textOverflow: "ellipsis",
              color: props.selected ? "white" : "black",
            }
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};